module.exports = __webpack_public_path__ + "static/img/logo.24f28f3d.png";